(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
(function(){
  'use strict';
  function init(root){
    if(root.dataset.fvcReady)return;
    root.dataset.fvcReady='true';
    var form=root.querySelector('[data-fvc-form]');
    if(!form)return;
    var status=root.querySelector('[data-fvc-status]');
    var inputs=Array.prototype.slice.call(form.querySelectorAll('[data-fvc-qty]'));
    var note=form.querySelector('[data-fvc-note]');
    var originalNote=note?note.value:'';
    var submitting=false;
    function controls(input){
      var box=input.closest('.fvc__quantity');
      var minus=box.querySelector('[data-fvc-step="-1"]');
      if(minus)minus.disabled=Number(input.value)<=0;
    }
    function changed(){
      var dirty=inputs.some(function(input){return input.value!==input.dataset.initial;})||(note&&note.value!==originalNote);
      form.classList.toggle('is-dirty',!!dirty);
      status.textContent=dirty?root.dataset.changedMessage:'';
    }
    inputs.forEach(function(input){
      controls(input);
      input.addEventListener('input',function(){
        input.setCustomValidity('');
        var error=input.closest('[data-fvc-item]').querySelector('[data-fvc-line-error]');
        if(error){error.textContent='';error.hidden=true;}
        controls(input);changed();
      });
    });
    form.querySelectorAll('[data-fvc-step]').forEach(function(button){
      button.hidden=false;
      button.addEventListener('click',function(){
        var input=button.closest('.fvc__quantity').querySelector('[data-fvc-qty]');
        if(!input.checkValidity())input.value=input.dataset.initial||'1';
        var next=Math.max(0,Number(input.value)+Number(button.dataset.fvcStep));
        input.value=String(next);
        input.dispatchEvent(new Event('input',{bubbles:true}));
        input.dispatchEvent(new Event('change',{bubbles:true}));
      });
    });
    if(note)note.addEventListener('input',changed);
    form.addEventListener('invalid',function(event){
      if(!event.target.matches('[data-fvc-qty]'))return;
      var error=event.target.closest('[data-fvc-item]').querySelector('[data-fvc-line-error]');
      if(error){error.textContent=root.dataset.invalidMessage;error.hidden=false;}
    },true);
    form.addEventListener('submit',function(event){
      if(submitting){event.preventDefault();return;}
      if(!form.checkValidity()){event.preventDefault();form.reportValidity();return;}
      submitting=true;
      form.classList.add('is-submitting');
      form.setAttribute('aria-busy','true');
      status.textContent=root.dataset.loadingMessage;
      // Keep submit buttons enabled: Shopify needs the clicked checkout/update name in the native POST.
    });
    window.addEventListener('pageshow',function(){
      submitting=false;form.classList.remove('is-submitting');form.removeAttribute('aria-busy');changed();
    });
  }
  function mount(scope){
    if(scope.matches&&scope.matches('[data-fv-cart]'))init(scope);
    scope.querySelectorAll('[data-fv-cart]').forEach(init);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){mount(document);});
  else mount(document);
  document.addEventListener('shopify:section:load',function(event){mount(event.target);});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floravita-bienvenida"]) return;
  try {
    
(function(){
  function mount(root){
    if(!root||root.dataset.fvWelcomeMounted)return;
    root.dataset.fvWelcomeMounted='true';
    var nodes=root.querySelectorAll('[data-fv-welcome-reveal]');
    var observer=null;
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
    function showAll(){if(observer){observer.disconnect();observer=null;}root.classList.remove('is-enhanced');nodes.forEach(function(node){node.classList.add('is-visible');});}
    if(root.dataset.fvWelcomeMotion==='true'&&!reduce.matches&&'IntersectionObserver'in window){
      try{observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}});},{threshold:.07,rootMargin:'0px 0px -24px 0px'});nodes.forEach(function(node){observer.observe(node);});root.classList.add('is-enhanced');}catch(error){showAll();}
    }
    function onReducedMotion(event){if(event.matches)showAll();}
    if(reduce.addEventListener)reduce.addEventListener('change',onReducedMotion);
    var success=root.querySelector('[data-fv-welcome-success]');
    if(success)success.focus({preventScroll:true});
    root.fvWelcomeDestroy=function(){if(observer)observer.disconnect();if(reduce.removeEventListener)reduce.removeEventListener('change',onReducedMotion);};
  }
  function scan(scope){if(scope.matches&&scope.matches('[data-fv-welcome]'))mount(scope);scope.querySelectorAll('[data-fv-welcome]').forEach(mount);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){scan(document);});else scan(document);
  document.addEventListener('shopify:section:load',function(event){scan(event.target);});
  document.addEventListener('shopify:section:unload',function(event){event.target.querySelectorAll('[data-fv-welcome]').forEach(function(root){if(root.fvWelcomeDestroy)root.fvWelcomeDestroy();});});
  document.addEventListener('shopify:block:select',function(event){var block=event.target;if(!block.closest('[data-fv-welcome]'))return;block.classList.add('is-visible');var parent=block.closest('[data-fv-welcome-reveal]');if(parent)parent.classList.add('is-visible');});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floravita-home"] && !Shopify.designMode) return;
  try {
    

(function () {
if (window.__floravitaHomeExperienceV11) {
window.__floravitaHomeExperienceV11.initializeWithin(document);
return;
}

var selector = '.fv-home[data-fv-home]';
var instances = new WeakMap();
var nativeHeader = { owners: new Set(), target: null, placeholder: null, active: false, naturalHeight: 0, resetFrame: 0, originalMarker: null, supported: true };

function headerAllowed(root) {
return root.getAttribute('data-fv-header-integration') !== 'false' && !(window.Shopify && window.Shopify.designMode);
}

function resetHeaderFrame() {
if (nativeHeader.resetFrame) window.cancelAnimationFrame(nativeHeader.resetFrame);
document.body.classList.add('fv-home-header-reset');
nativeHeader.resetFrame = window.requestAnimationFrame(function () {
nativeHeader.resetFrame = 0;
document.body.classList.remove('fv-home-header-reset');
});
}

function restoreNativeHeader() {
if (nativeHeader.resetFrame) window.cancelAnimationFrame(nativeHeader.resetFrame);
nativeHeader.resetFrame = 0;
document.body.classList.add('fv-home-header-reset');
document.body.classList.remove('fv-home-header-integrated', 'fv-home-header-overlay', 'fv-home-header-ready');
if (nativeHeader.target) {
if (nativeHeader.originalMarker === null) nativeHeader.target.removeAttribute('data-fv-integrated-header');
else nativeHeader.target.setAttribute('data-fv-integrated-header', nativeHeader.originalMarker);
}
if (nativeHeader.placeholder) nativeHeader.placeholder.remove();
document.body.classList.remove('fv-home-header-reset');
nativeHeader.target = null;
nativeHeader.placeholder = null;
nativeHeader.active = false;
nativeHeader.naturalHeight = 0;
nativeHeader.originalMarker = null;
nativeHeader.supported = true;
}

function releaseNativeHeader(root) {
var owned = nativeHeader.owners.delete(root);
if (!nativeHeader.owners.size && (owned || nativeHeader.target || nativeHeader.placeholder)) restoreNativeHeader();
}

function prepareNativeHeader(root) {
if (!headerAllowed(root)) {
releaseNativeHeader(root);
return false;
}
nativeHeader.owners.add(root);
if (nativeHeader.target && nativeHeader.target.isConnected) return true;
if (nativeHeader.target) restoreNativeHeader();
var target = document.querySelector('[data-header-section]') || document.getElementById('shopify-section-header') || document.querySelector('.site-header');
if (!target || root.contains(target)) return false;
nativeHeader.target = target;
nativeHeader.originalMarker = target.getAttribute('data-fv-integrated-header');
nativeHeader.naturalHeight = Math.ceil(target.getBoundingClientRect().height);
target.setAttribute('data-fv-integrated-header', 'native');
var placeholder = document.createElement('div');
placeholder.className = 'fv-home__header-placeholder';
placeholder.setAttribute('data-fv-header-placeholder', '');
placeholder.setAttribute('aria-hidden', 'true');
placeholder.setAttribute('inert', '');
placeholder.hidden = true;
placeholder.style.display = 'none';
placeholder.style.height = nativeHeader.naturalHeight + 'px';
target.parentNode.insertBefore(placeholder, target);
nativeHeader.placeholder = placeholder;
document.body.classList.add('fv-home-header-ready');
return true;
}

function updateNativeHeader(root, overlay) {
if (!prepareNativeHeader(root) || !nativeHeader.supported) return;
document.body.classList.toggle('fv-home-header-overlay', overlay);
if (overlay) return;
var target = nativeHeader.target;
var placeholder = nativeHeader.placeholder;
var next = nativeHeader.active ? window.scrollY >= 56 : window.scrollY > 90;
if (!nativeHeader.active) {
nativeHeader.naturalHeight = Math.ceil(target.getBoundingClientRect().height);
placeholder.style.height = nativeHeader.naturalHeight + 'px';
}
if (next === nativeHeader.active || nativeHeader.naturalHeight <= 0) return;
if (next) {
placeholder.hidden = false;
placeholder.style.display = 'block';
document.body.classList.add('fv-home-header-integrated');
if (window.getComputedStyle(target).position !== 'fixed') {
document.body.classList.remove('fv-home-header-integrated');
placeholder.hidden = true;
placeholder.style.display = 'none';
nativeHeader.supported = false;
return;
}
} else {
resetHeaderFrame();
document.body.classList.remove('fv-home-header-integrated');
target.getBoundingClientRect();
placeholder.hidden = true;
placeholder.style.display = 'none';
}
nativeHeader.active = next;
}

function rootsWithin(scope) {
var roots = [];
if (scope.matches && scope.matches(selector)) roots.push(scope);
if (scope.querySelectorAll) roots = roots.concat(Array.from(scope.querySelectorAll(selector)));
return roots;
}

function initialize(root) {
if (instances.has(root)) return;
root.classList.toggle('fv-editor-mode', Boolean(window.Shopify && window.Shopify.designMode));
var controller = new AbortController();
var signal = controller.signal;
var motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
var nav = root.querySelector('[data-fv-home-nav]');
var indicator = root.querySelector('[data-fv-nav-indicator]');
var navToggle = root.querySelector('[data-fv-nav-toggle]');
var navLinks = root.querySelector('[data-fv-nav-links]');
var navCurrent = root.querySelector('[data-fv-nav-current]');
var navCurrentDefault = navCurrent && navCurrent.textContent;
var mobileNavMedia = window.matchMedia('(max-width: 749px)');
var expandItems = Array.from(root.querySelectorAll('[data-fv-expand]'));
var links = Array.from(root.querySelectorAll('[data-fv-home-link]'));
var sections = Array.from(root.querySelectorAll('[data-fv-home-section][id]'));
var progress = root.querySelector('[data-fv-home-progress]');
var reveals = Array.from(root.querySelectorAll('[data-fv-reveal]'));
var photoItems = Array.from(root.querySelectorAll('[data-fv-photo-reveal]'));
var hero = root.querySelector('[data-fv-hero]');
var staggerChildren = new Map();
var revealStyles = new Map();
var filterContainers = Array.from(root.querySelectorAll('[data-fv-filters]'));
var filters = Array.from(root.querySelectorAll('[data-fv-filter]'));
var availability = root.querySelector('[data-fv-availability]');
var originalAvailability = availability && availability.checked;
var currentFamily = 'all';
var cards = Array.from(root.querySelectorAll('[data-fv-product-card]'));
var filterStatus = root.querySelector('[data-fv-filter-status]');
var templateNode = root.querySelector('[data-fv-count-template]');
var countTemplate = templateNode && templateNode.getAttribute('data-fv-count-template') || '{count}';
var emptyFilter = root.querySelector('[data-fv-empty-filter]');
var galleries = Array.from(root.querySelectorAll('[data-fv-gallery-track]'));
var mobileToggles = Array.from(document.querySelectorAll('.js-mobile-nav-toggle'));
var cartPopups = Array.from(document.querySelectorAll('[data-cart-popup-wrapper]'));
var revealObserver = null;
var photoObserver = null;
var expandObserver = null;
var resizeObserver = null;
var stateObserver = null;
var frame = 0;
var navHeight = 0;
var headerOffset = 0;
var activeId = null;
var destroyed = false;
var filterGeneration = 0;
var animations = new Set();
var transitions = new Set();
var accordionStates = new Map();
var navDisclosure = null;
var temporaryFocus = new Set();
var galleryStates = new Map();
var originalFilterVisibility = new Map();
var originalPressed = new Map();
var originalStatus = filterStatus && filterStatus.textContent;

function rememberStyle(element, names) {
var values = {};
names.forEach(function (name) { values[name] = [element.style.getPropertyValue(name), element.style.getPropertyPriority(name)]; });
return values;
}

function restoreStyle(element, values) {
Object.keys(values).forEach(function (name) {
if (values[name][0]) element.style.setProperty(name, values[name][0], values[name][1]);
else element.style.removeProperty(name);
});
}

function cssHeight(element, borderBoxHeight) {
var styles = window.getComputedStyle(element);
var extra = styles.boxSizing === 'border-box' ? 0 : parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom) + parseFloat(styles.borderTopWidth) + parseFloat(styles.borderBottomWidth);
return Math.max(0, borderBoxHeight - extra) + 'px';
}

function motionEnabled() {
return !motionPreference.matches && root.getAttribute('data-fv-animations') !== 'false' && !(window.Shopify && window.Shopify.designMode);
}

function reveal(item) {
item.classList.remove('fv-reveal-pending');
item.classList.add('is-revealed');
if (revealObserver) revealObserver.unobserve(item);
}

function revealWithin(scope) {
if (!scope || !scope.contains) return;
reveals.forEach(function (item) {
if (item === scope || scope.contains(item) || item.contains(scope)) reveal(item);
});
expandItems.forEach(function (item) {
if (item === scope || scope.contains(item) || item.contains(scope)) expand(item);
});
photoItems.forEach(function (item) {
if (item === scope || scope.contains(item) || item.contains(scope)) revealPhoto(item);
});
}

function revealAll() {
reveals.forEach(reveal);
if (revealObserver) revealObserver.disconnect();
root.classList.remove('fv-motion-ready');
}

function revealPhoto(item) {
item.classList.remove('fv-photo-pending');
item.classList.add('is-photo-revealed');
if (photoObserver) photoObserver.unobserve(item);
}

function revealAllPhotos() {
photoItems.forEach(revealPhoto);
if (photoObserver) photoObserver.disconnect();
root.classList.remove('fv-photo-motion-ready');
}

function prepareStagger() {
var orders = new Map();
reveals.forEach(function (item) {
if (item.closest('[data-fv-hero]')) return;
var section = item.closest('[data-fv-home-section]') || root;
var order = orders.get(section) || 0;
revealStyles.set(item, rememberStyle(item, ['--fv-delay']));
item.style.setProperty('--fv-delay', Math.min(order, 3) * 100 + 'ms');
orders.set(section, order + 1);
var children = Array.from(item.children).filter(function (child) { return child.matches('p,h2,h3,h4,.rte,.fv-home__text-link,.fv-home__signature'); });
if (!children.length) {
var group = item.firstElementChild;
if (group && group.tagName === 'DIV' && !group.querySelector('img,svg')) children = Array.from(group.children).filter(function (child) { return child.matches('p,h2,h3,h4,.rte,.fv-home__text-link'); });
}
children.forEach(function (child, index) {
if (!staggerChildren.has(child)) staggerChildren.set(child, { hadClass: child.classList.contains('fv-stagger-child'), styles: rememberStyle(child, ['--fv-text-delay']) });
child.classList.add('fv-stagger-child');
child.style.setProperty('--fv-text-delay', Math.min(index, 4) * 70 + 'ms');
});
});
}

function heroIntro() {
root.classList.add('is-hero-ready');
if (!hero || !motionEnabled()) return;
var bounds = hero.getBoundingClientRect();
if (bounds.bottom <= 0 || bounds.top >= window.innerHeight) return;
var photo = hero.querySelector('.fv-home__opening-photo');
var copy = hero.querySelector('.fv-home__opening-copy');
if (photo) animate(photo, [{ transform: 'scale(1.045)' }, { transform: 'scale(1)' }], { duration: 2400, easing: 'cubic-bezier(.16,1,.3,1)' });
if (copy) animate(copy, [{ opacity: 0.78, transform: 'translate3d(0,12px,0)' }, { opacity: 1, transform: 'translate3d(0,0,0)' }], { duration: 1400, delay: 100, easing: 'cubic-bezier(.16,1,.3,1)' });
}

function expand(item) {
item.classList.add('is-expanded');
if (expandObserver) expandObserver.unobserve(item);
}

function expandAll() {
expandItems.forEach(expand);
if (expandObserver) expandObserver.disconnect();
root.classList.remove('fv-expand-ready');
}

function cancelMotion() {
accordionStates.forEach(function (state, details) {
if (state.animation) finishAccordion(details, state, state.targetOpen);
});
if (navDisclosure && navDisclosure.animation) finishDisclosure(navDisclosure.targetOpen);
animations.forEach(function (animation) { animation.cancel(); });
transitions.forEach(function (transition) { transition.skipTransition(); });
}

function animate(element, keyframes, options) {
if (!motionEnabled() || typeof element.animate !== 'function') return null;
var animation = element.animate(keyframes, options);
animations.add(animation);
animation.finished.then(function () {
animations.delete(animation);
}, function () {
animations.delete(animation);
});
return animation;
}

function targetFor(link) {
if (!link || !link.hash) return null;
if (link.origin !== window.location.origin || link.pathname !== window.location.pathname || link.search !== window.location.search) return null;
var id;
try { id = decodeURIComponent(link.hash.slice(1)); } catch (error) { return null; }
var target = document.getElementById(id);
return target && root.contains(target) && target.matches('[data-fv-home-section]') ? target : null;
}

function measure() {
var nextHeight = nav && !nav.hidden ? Math.ceil(nav.getBoundingClientRect().height) : 0;
var nextOffset = 0;
var header = document.querySelector('.site-header');
var headerContainer = header;
while (headerContainer && headerContainer !== document.body) {
var position = window.getComputedStyle(headerContainer).position;
if (position === 'fixed' || position === 'sticky') {
var bounds = headerContainer.getBoundingClientRect();
if (bounds.top <= 1 && bounds.bottom > 0) nextOffset = Math.max(0, Math.ceil(bounds.bottom));
break;
}
headerContainer = headerContainer.parentElement;
}
if (nextHeight !== navHeight || !root.style.getPropertyValue('--fv-nav-height')) {
navHeight = nextHeight;
root.style.setProperty('--fv-nav-height', navHeight + 'px');
}
if (nextOffset !== headerOffset || !root.style.getPropertyValue('--fv-header-offset')) {
headerOffset = nextOffset;
root.style.setProperty('--fv-header-offset', headerOffset + 'px');
}
}

function centerLink(link) {
if (!nav || !link || mobileNavMedia.matches) return;
var parent = link.parentElement;
while (parent && root.contains(parent)) {
var overflow = window.getComputedStyle(parent).overflowX;
if (parent.scrollWidth > parent.clientWidth + 1 && (overflow === 'auto' || overflow === 'scroll')) {
var parentBounds = parent.getBoundingClientRect();
var linkBounds = link.getBoundingClientRect();
var next = parent.scrollLeft + linkBounds.left - parentBounds.left - (parent.clientWidth - linkBounds.width) / 2;
parent.scrollTo({ left: next, behavior: motionEnabled() ? 'smooth' : 'auto' });
break;
}
if (parent === nav) break;
parent = parent.parentElement;
}
}

function setActive(id) {
if (activeId === id) return;
activeId = id;
var activeLink = null;
links.forEach(function (link) {
if (nav && !nav.contains(link)) return;
var target = targetFor(link);
var current = Boolean(target && target.id === id);
link.classList.toggle('is-current', current);
if (current) {
link.setAttribute('aria-current', 'location');
activeLink = link;
} else link.removeAttribute('aria-current');
});
if (navCurrent) navCurrent.textContent = activeLink && (!navLinks || navLinks.contains(activeLink)) ? activeLink.textContent.trim() : navCurrentDefault;
centerLink(activeLink);
updateIndicator();
}

function updateIndicator() {
if (!indicator || !nav) return;
var current = (navLinks || nav).querySelector('[data-fv-home-link][aria-current="location"]');
if (!current || mobileNavMedia.matches || current.getBoundingClientRect().width === 0) {
indicator.hidden = true;
return;
}
indicator.hidden = false;
var parent = indicator.offsetParent || indicator.parentElement;
var parentBounds = parent.getBoundingClientRect();
var bounds = current.getBoundingClientRect();
var x = bounds.left - parentBounds.left + parent.scrollLeft - parent.clientLeft;
indicator.style.setProperty('--fv-indicator-x', x.toFixed(2) + 'px');
indicator.style.setProperty('--fv-indicator-width', bounds.width.toFixed(2) + 'px');
indicator.style.transform = 'translateX(' + x.toFixed(2) + 'px) translateY(-50%)';
indicator.style.width = bounds.width.toFixed(2) + 'px';
root.classList.add('fv-nav-indicator-ready');
}

function finishAccordion(details, state, open) {
var existing = state.animation;
state.animation = null;
state.targetOpen = open;
details.open = open;
restoreStyle(details, state.styles);
details.classList.remove('fv-accordion-animating');
if (existing) existing.cancel();
schedule();
}

function toggleAccordion(details) {
var state = accordionStates.get(details);
if (!state) {
state = { animation: null, targetOpen: details.open, styles: rememberStyle(details, ['height', 'overflow']) };
accordionStates.set(details, state);
}
var start = details.getBoundingClientRect().height;
var open = state.animation ? !state.targetOpen : !details.open;
var previous = state.animation;
state.animation = null;
if (previous) previous.cancel();
state.targetOpen = open;
details.style.height = 'auto';
details.open = open;
var end = details.getBoundingClientRect().height;
details.open = true;
revealWithin(details);
details.style.height = cssHeight(details, start);
details.style.overflow = 'hidden';
details.classList.add('fv-accordion-animating');
var animation = animate(details, [{ height: cssHeight(details, start) }, { height: cssHeight(details, end) }], { duration: 480, easing: 'cubic-bezier(.22,.68,.24,1)', fill: 'forwards' });
if (!animation) {
finishAccordion(details, state, open);
return;
}
state.animation = animation;
animation.finished.then(function () {
if (state.animation === animation) finishAccordion(details, state, open);
}, function () {});
}

function finishDisclosure(open) {
if (!navDisclosure) return;
var existing = navDisclosure.animation;
navDisclosure.animation = null;
navDisclosure.open = open;
navDisclosure.targetOpen = open;
navLinks.hidden = !open;
navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
restoreStyle(navLinks, navDisclosure.styles);
nav.classList.toggle('fv-nav-disclosure-open', open && mobileNavMedia.matches);
if (existing) existing.cancel();
schedule();
}

function setDisclosure(open, immediate) {
if (!navDisclosure) return;
if (!mobileNavMedia.matches) {
finishDisclosure(true);
return;
}
var start = navLinks.hidden ? 0 : navLinks.getBoundingClientRect().height;
var startOpacity = navLinks.hidden ? 0 : parseFloat(window.getComputedStyle(navLinks).opacity);
var existing = navDisclosure.animation;
navDisclosure.animation = null;
if (existing) existing.cancel();
navDisclosure.targetOpen = open;
navDisclosure.open = open;
navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
nav.classList.toggle('fv-nav-disclosure-open', open);
if (immediate || !motionEnabled()) {
finishDisclosure(open);
return;
}
navLinks.hidden = false;
navLinks.style.height = 'auto';
var end = open ? navLinks.getBoundingClientRect().height : 0;
navLinks.style.height = cssHeight(navLinks, start);
navLinks.style.overflow = 'hidden';
var animation = animate(navLinks, [{ height: cssHeight(navLinks, start), opacity: startOpacity }, { height: cssHeight(navLinks, end), opacity: open ? 1 : 0 }], { duration: 420, easing: 'cubic-bezier(.22,.68,.24,1)', fill: 'forwards' });
if (!animation) {
finishDisclosure(open);
return;
}
navDisclosure.animation = animation;
animation.finished.then(function () {
if (navDisclosure.animation === animation) finishDisclosure(open);
}, function () {});
}

function disclosureMode() {
if (!navDisclosure) return;
var focusedLink = navLinks.contains(document.activeElement);
navToggle.hidden = !mobileNavMedia.matches;
finishDisclosure(!mobileNavMedia.matches);
if (focusedLink && mobileNavMedia.matches) navToggle.focus({ preventScroll: true });
updateIndicator();
schedule();
}

function overlayIsOpen() {
return document.body.classList.contains('js-drawer-open') || document.body.classList.contains('prevent-scrolling') ||
Boolean(root.querySelector('dialog[open]')) || mobileToggles.some(function (button) { return button.getAttribute('aria-expanded') === 'true'; }) ||
cartPopups.some(function (popup) { return !popup.hidden && !popup.classList.contains('cart-popup-wrapper--hidden'); });
}

function galleryPosition(track) {
return Math.abs(track.scrollLeft);
}

function updateGallery(track) {
var state = galleryStates.get(track);
if (!state) return;
var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
var position = galleryPosition(track);
if (state.previous) state.previous.disabled = maximum <= 2 || position <= 2;
if (state.next) state.next.disabled = maximum <= 2 || position >= maximum - 2;
}

function moveGallery(track, direction) {
var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
var distance = Math.max(160, Math.round(track.clientWidth * 0.85));
var position = Math.min(maximum, Math.max(0, galleryPosition(track) + direction * distance));
var rtl = window.getComputedStyle(track).direction === 'rtl';
track.scrollTo({ left: rtl ? -position : position, behavior: motionEnabled() ? 'smooth' : 'auto' });
}

function update() {
frame = 0;
if (destroyed || !root.isConnected) return;
var overlay = overlayIsOpen();
root.classList.toggle('fv-overlay-open', overlay);
updateNativeHeader(root, overlay);
if (overlay && navDisclosure && mobileNavMedia.matches && navDisclosure.open) setDisclosure(false, true);
measure();
if (nav) {
var navBounds = nav.getBoundingClientRect();
var position = window.getComputedStyle(nav).position;
var engaged = (position === 'sticky' || position === 'fixed') && navBounds.height > 0 && navBounds.top <= headerOffset + 1 && window.scrollY > 0;
root.classList.toggle('fv-nav-engaged', engaged);
nav.classList.toggle('fv-nav-engaged', engaged);
}
var current = null;
var threshold = headerOffset + navHeight + 32;
sections.forEach(function (section) {
var bounds = section.getBoundingClientRect();
if (!section.hidden && bounds.height > 0) {
if (!current) current = section;
if (bounds.top <= threshold) current = section;
}
});
if (current) setActive(current.id);
updateIndicator();
if (progress) {
var rootBounds = root.getBoundingClientRect();
var total = Math.max(1, rootBounds.height - window.innerHeight);
var fraction = Math.min(1, Math.max(0, -rootBounds.top / total));
progress.style.transform = 'scaleX(' + fraction.toFixed(4) + ')';
}
galleries.forEach(updateGallery);
}

function schedule() {
if (!destroyed && !frame) frame = window.requestAnimationFrame(update);
}

function focusTarget(target) {
if (!target.hasAttribute('tabindex') && !target.matches('a[href],button,input,select,textarea,summary')) {
target.setAttribute('tabindex', '-1');
temporaryFocus.add(target);
target.addEventListener('blur', function () {
if (temporaryFocus.has(target)) {
target.removeAttribute('tabindex');
temporaryFocus.delete(target);
}
}, { once: true, signal: signal });
}
target.focus({ preventScroll: true });
}

function moveTo(target, remember) {
if (!target || target.hidden) return;
revealWithin(target);
measure();
var gap = nav && nav.nextElementSibling === target ? 0 : 20;
var top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerOffset - navHeight - gap);
focusTarget(target);
window.scrollTo({ top: top, behavior: motionEnabled() ? 'smooth' : 'auto' });
if (remember) {
var hash = '#' + encodeURIComponent(target.id);
if (window.location.hash !== hash) window.history.pushState(null, '', hash);
}
setActive(target.id);
schedule();
}

function filterValue(button) {
var value = button.getAttribute('data-fv-filter') || button.value || 'all';
return ['all', 'arco', 'nexo', 'other'].indexOf(value) !== -1 ? value : 'all';
}

function applyFilter(value, announce) {
var count = 0;
cards.forEach(function (card) {
var familyMatches = value === 'all' || card.getAttribute('data-fv-model') === value;
var availableMatches = !availability || !availability.checked || card.getAttribute('data-fv-available') === 'true';
var visible = familyMatches && availableMatches;
card.hidden = !visible;
if (visible) {
count += 1;
if (announce) revealWithin(card);
}
});
filters.forEach(function (button) { button.setAttribute('aria-pressed', filterValue(button) === value ? 'true' : 'false'); });
if (emptyFilter) emptyFilter.hidden = count !== 0;
if (filterStatus && announce) filterStatus.textContent = countTemplate.replace(/\{count\}/g, String(count));
schedule();
}

function chooseFilter(value) {
currentFamily = value;
var generation = ++filterGeneration;
transitions.forEach(function (transition) { transition.skipTransition(); });
var apply = function () {
if (!destroyed && generation === filterGeneration) applyFilter(value, true);
};
if (motionEnabled() && typeof document.startViewTransition === 'function') {
try {
var transition = document.startViewTransition(apply);
transitions.add(transition);
transition.finished.then(function () {
transitions.delete(transition);
}, function () {
transitions.delete(transition);
});
transition.ready.catch(function () {});
} catch (error) { apply(); }
} else apply();
}

root.addEventListener('click', function (event) {
if (!(event.target instanceof Element)) return;
if (navToggle && (event.target === navToggle || navToggle.contains(event.target))) {
event.preventDefault();
if (navDisclosure) setDisclosure(!navDisclosure.targetOpen, false);
return;
}
var summary = event.target.closest('summary');
var details = summary && summary.parentElement;
if (details instanceof HTMLDetailsElement && root.contains(details) && !event.defaultPrevented && !event.target.closest('a,button,input,select,textarea,label') && motionEnabled() && typeof details.animate === 'function') {
event.preventDefault();
toggleAccordion(details);
return;
}
var filter = event.target.closest('[data-fv-filter]');
if (filter && root.contains(filter) && !filter.disabled) {
event.preventDefault();
chooseFilter(filterValue(filter));
return;
}
var link = event.target.closest('[data-fv-home-link]');
if (link && root.contains(link) && event.button === 0 && !event.ctrlKey && !event.metaKey && !event.altKey && !event.shiftKey && !link.hasAttribute('download') && (!link.target || link.target === '_self')) {
var target = targetFor(link);
if (target) {
event.preventDefault();
if (navDisclosure && mobileNavMedia.matches) setDisclosure(false, true);
moveTo(target, true);
}
}
}, { signal: signal });

root.addEventListener('focusin', function (event) {
if (event.target instanceof Element) revealWithin(event.target);
}, { signal: signal });

root.addEventListener('change', function (event) {
if (availability && event.target === availability && !availability.disabled) chooseFilter(currentFamily);
}, { signal: signal });

root.addEventListener('toggle', function (event) {
var details = event.target;
if (!(details instanceof HTMLDetailsElement)) return;
var state = accordionStates.get(details);
if (state && state.animation) {
if (!details.open) finishAccordion(details, state, false);
schedule();
return;
}
if (details.open) {
revealWithin(details);
}
schedule();
}, { capture: true, signal: signal });

if (motionEnabled()) prepareStagger();
if ('IntersectionObserver' in window && motionEnabled()) {
revealObserver = new IntersectionObserver(function (entries) {
entries.forEach(function (entry) { if (entry.isIntersecting) reveal(entry.target); });
}, { rootMargin: '0px 0px -32px 0px', threshold: 0.04 });
reveals.forEach(function (item) {
var inHero = item.matches('[data-fv-hero]') || item.closest('[data-fv-hero]') || item.querySelector('[data-fv-hero]');
var bounds = item.getBoundingClientRect();
if (inHero || bounds.top < window.innerHeight || bounds.bottom <= 0 || item.matches(':focus-within') || item.hidden) reveal(item);
else {
item.classList.add('fv-reveal-pending');
revealObserver.observe(item);
}
});
root.classList.add('fv-motion-ready');
} else revealAll();

if ('IntersectionObserver' in window && motionEnabled() && photoItems.length) {
photoObserver = new IntersectionObserver(function (entries) {
entries.forEach(function (entry) { if (entry.isIntersecting) revealPhoto(entry.target); });
}, { rootMargin: '0px 0px -40px 0px', threshold: 0.04 });
photoItems.forEach(function (item) {
var bounds = item.getBoundingClientRect();
if (item.closest('[data-fv-hero]') || bounds.top < window.innerHeight || bounds.bottom <= 0 || item.matches(':focus-within') || item.hidden) revealPhoto(item);
else {
item.classList.add('fv-photo-pending');
photoObserver.observe(item);
}
});
root.classList.add('fv-photo-motion-ready');
} else revealAllPhotos();
heroIntro();

if ('IntersectionObserver' in window && motionEnabled() && expandItems.length) {
expandObserver = new IntersectionObserver(function (entries) {
entries.forEach(function (entry) { if (entry.isIntersecting) expand(entry.target); });
}, { rootMargin: '0px 0px -32px 0px', threshold: 0.1 });
expandItems.forEach(function (item) {
var bounds = item.getBoundingClientRect();
if (bounds.top < window.innerHeight || item.closest('[data-fv-hero]')) expand(item);
else expandObserver.observe(item);
});
root.classList.add('fv-expand-ready');
} else expandAll();

if (nav && navToggle && navLinks) {
navDisclosure = { animation: null, open: true, targetOpen: true, styles: rememberStyle(navLinks, ['height', 'overflow']) };
root.classList.add('fv-nav-disclosure-ready');
disclosureMode();
nav.addEventListener('keydown', function (event) {
if (event.key === 'Escape' && mobileNavMedia.matches && navDisclosure.open) {
event.preventDefault();
setDisclosure(false, true);
navToggle.focus({ preventScroll: true });
}
}, { signal: signal });
document.addEventListener('click', function (event) {
if (event.target instanceof Element && mobileNavMedia.matches && navDisclosure.open && !nav.contains(event.target)) setDisclosure(false, false);
}, { signal: signal });
mobileNavMedia.addEventListener('change', disclosureMode, { signal: signal });
}
if (nav) nav.addEventListener('scroll', schedule, { passive: true, capture: true, signal: signal });

if ((filters.length || availability) && cards.length) {
filterContainers.forEach(function (container) {
originalFilterVisibility.set(container, container.hidden);
container.hidden = false;
});
filters.forEach(function (button) { originalPressed.set(button, button.getAttribute('aria-pressed')); });
root.classList.add('fv-filter-ready');
applyFilter('all', false);
}

galleries.forEach(function (track) {
var owner = track.closest('[data-fv-gallery]') || track.parentElement;
var previous = owner && owner.querySelector('[data-fv-gallery-prev]');
var next = owner && owner.querySelector('[data-fv-gallery-next]');
galleryStates.set(track, { previous: previous, next: next });
if (previous) previous.addEventListener('click', function (event) {
event.preventDefault();
moveGallery(track, -1);
}, { signal: signal });
if (next) next.addEventListener('click', function (event) {
event.preventDefault();
moveGallery(track, 1);
}, { signal: signal });
track.addEventListener('scroll', schedule, { passive: true, signal: signal });
track.addEventListener('keydown', function (event) {
if (event.target !== track || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
event.preventDefault();
var rtl = window.getComputedStyle(track).direction === 'rtl';
moveGallery(track, (event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
}, { signal: signal });
updateGallery(track);
});

window.addEventListener('scroll', schedule, { passive: true, signal: signal });
window.addEventListener('resize', schedule, { passive: true, signal: signal });
window.addEventListener('pageshow', schedule, { signal: signal });
window.addEventListener('hashchange', function () {
var matching = links.find(function (link) { return link.hash === window.location.hash; });
var target = targetFor(matching);
if (target) moveTo(target, false);
}, { signal: signal });
motionPreference.addEventListener('change', function () {
if (!motionEnabled()) {
revealAll();
revealAllPhotos();
expandAll();
cancelMotion();
}
schedule();
}, { signal: signal });

if ('ResizeObserver' in window) {
resizeObserver = new ResizeObserver(schedule);
resizeObserver.observe(root);
if (nav) resizeObserver.observe(nav);
links.forEach(function (link) { if (nav && nav.contains(link)) resizeObserver.observe(link); });
var header = document.querySelector('.site-header');
if (header) resizeObserver.observe(header);
if (prepareNativeHeader(root) && nativeHeader.target) resizeObserver.observe(nativeHeader.target);
galleries.forEach(function (track) { resizeObserver.observe(track); });
}

if ('MutationObserver' in window) {
stateObserver = new MutationObserver(function () {
if (!motionEnabled()) {
revealAll();
revealAllPhotos();
expandAll();
cancelMotion();
}
schedule();
});
stateObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
stateObserver.observe(root, { attributes: true, attributeFilter: ['data-fv-animations', 'data-fv-header-integration', 'open'], subtree: true });
mobileToggles.forEach(function (button) { stateObserver.observe(button, { attributes: true, attributeFilter: ['aria-expanded'] }); });
cartPopups.forEach(function (popup) { stateObserver.observe(popup, { attributes: true, attributeFilter: ['class', 'hidden'] }); });
}

var destroy = function () {
if (destroyed) return;
destroyed = true;
filterGeneration += 1;
controller.abort();
if (frame) window.cancelAnimationFrame(frame);
if (revealObserver) revealObserver.disconnect();
if (photoObserver) photoObserver.disconnect();
if (expandObserver) expandObserver.disconnect();
if (resizeObserver) resizeObserver.disconnect();
if (stateObserver) stateObserver.disconnect();
cancelMotion();
revealAll();
revealAllPhotos();
releaseNativeHeader(root);
staggerChildren.forEach(function (state, child) {
restoreStyle(child, state.styles);
if (!state.hadClass) child.classList.remove('fv-stagger-child');
});
revealStyles.forEach(function (styles, item) { restoreStyle(item, styles); });
expandAll();
accordionStates.forEach(function (state, details) {
restoreStyle(details, state.styles);
details.classList.remove('fv-accordion-animating');
});
if (navDisclosure) {
navLinks.hidden = false;
navToggle.hidden = true;
navToggle.setAttribute('aria-expanded', 'true');
restoreStyle(navLinks, navDisclosure.styles);
nav.classList.remove('fv-nav-disclosure-open');
}
cards.forEach(function (card) { card.hidden = false; });
if (availability) availability.checked = originalAvailability;
originalFilterVisibility.forEach(function (hidden, container) { container.hidden = hidden; });
originalPressed.forEach(function (pressed, button) {
if (pressed === null) button.removeAttribute('aria-pressed');
else button.setAttribute('aria-pressed', pressed);
});
if (emptyFilter) emptyFilter.hidden = true;
if (filterStatus) filterStatus.textContent = originalStatus;
galleryStates.forEach(function (state) {
if (state.previous) state.previous.disabled = false;
if (state.next) state.next.disabled = false;
});
temporaryFocus.forEach(function (target) { target.removeAttribute('tabindex'); });
root.classList.remove('fv-filter-ready', 'fv-overlay-open', 'fv-nav-engaged', 'fv-nav-indicator-ready', 'fv-nav-disclosure-ready', 'fv-editor-mode', 'is-hero-ready');
if (nav) nav.classList.remove('fv-nav-engaged');
if (indicator) {
indicator.hidden = true;
indicator.style.removeProperty('transform');
indicator.style.removeProperty('width');
indicator.style.removeProperty('--fv-indicator-x');
indicator.style.removeProperty('--fv-indicator-width');
}
root.style.removeProperty('--fv-nav-height');
root.style.removeProperty('--fv-header-offset');
links.forEach(function (link) {
link.removeAttribute('aria-current');
link.classList.remove('is-current');
});
if (progress) progress.style.removeProperty('transform');
instances.delete(root);
};
instances.set(root, { destroy: destroy, revealWithin: revealWithin });
update();
}

function initializeWithin(scope) {
rootsWithin(scope).forEach(initialize);
}

document.addEventListener('shopify:section:load', function (event) {
initializeWithin(event.target);
});
document.addEventListener('shopify:section:unload', function (event) {
rootsWithin(event.target).forEach(function (root) {
var instance = instances.get(root);
if (instance) instance.destroy();
});
});
document.addEventListener('shopify:block:select', function (event) {
if (!(event.target instanceof Element)) return;
var root = event.target.closest(selector);
var instance = root && instances.get(root);
if (instance) instance.revealWithin(event.target);
});
window.__floravitaHomeExperienceV11 = { initializeWithin: initializeWithin };
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeWithin(document); }, { once: true });
else initializeWithin(document);
}());



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floravita-regalo"]) return;
  try {
    
(()=>{const init=(root)=>{if(root.dataset.fvgReady)return;root.dataset.fvgReady='true';let labels={};try{labels=JSON.parse(root.querySelector('[data-fvg-labels]').textContent)}catch(e){}const variant=root.querySelector('[data-fvg-variant]');const add=root.querySelector('[data-fvg-add]');const price=root.querySelector('[data-fvg-price]');const cardAmount=root.querySelector('[data-fvg-card-amount]');const stock=root.querySelector('[data-fvg-stock]');const status=root.querySelector('[data-fvg-selection-status]');const update=()=>{if(!variant)return;const option=variant.selectedOptions[0];if(!option)return;const available=option.dataset.available==='true';const money=option.dataset.money;price.textContent=money;cardAmount.textContent=money;stock.textContent=available?labels.available:labels.soldout;stock.classList.toggle('is-soldout',!available);add.disabled=!available;root.querySelector('[data-fvg-add-label]').textContent=available?labels.buy:labels.soldout;status.textContent=labels.selection+': '+money+'. '+stock.textContent};if(variant){variant.addEventListener('change',update);update()}const send=root.querySelector('[data-fvg-send]');if(send){const fields=root.querySelector('[data-fvg-recipient-fields]');const email=root.querySelector('[data-fvg-email]');const name=root.querySelector('[data-fvg-name]');const message=root.querySelector('[data-fvg-message]');const count=root.querySelector('[data-fvg-message-count]');const dedication=root.querySelector('[data-fvg-dedication]');const to=root.querySelector('[data-fvg-card-to]');const cardName=root.querySelector('[data-fvg-card-name]');root.querySelector('[data-fvg-nojs-flag]').disabled=true;root.querySelector('[data-fvg-toggle-label]').hidden=false;send.disabled=false;const preview=()=>{const label=name.value.trim();to.hidden=!send.checked||!label;cardName.textContent=label;count.textContent=message.value.length+' / 200';dedication.hidden=!send.checked||!message.value.trim();dedication.textContent=message.value.trim()};const toggle=()=>{fields.hidden=!send.checked;fields.disabled=!send.checked;email.required=send.checked;send.setAttribute('aria-expanded',String(send.checked));preview()};send.checked=!!email.value.trim();send.addEventListener('change',toggle);name.addEventListener('input',preview);message.addEventListener('input',preview);toggle()}const nodes=Array.from(root.querySelectorAll('[data-fvg-reveal]'));if(root.dataset.motion==='true'&&!matchMedia('(prefers-reduced-motion:reduce)').matches&&'IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}})},{threshold:.08,rootMargin:'0px 0px -20px 0px'});root.classList.add('is-ready');nodes.forEach(node=>observer.observe(node));root.fvgObserver=observer}const form=root.querySelector('.fvg__form');if(form){form.addEventListener('submit',event=>{if(variant&&variant.selectedOptions[0]?.dataset.available!=='true'){event.preventDefault();stock.focus();return}if(!form.checkValidity()){event.preventDefault();form.reportValidity()}})}};const boot=scope=>{if(scope.matches?.('[data-fv-gift]'))init(scope);scope.querySelectorAll?.('[data-fv-gift]').forEach(init)};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(document));else boot(document);document.addEventListener('shopify:section:load',event=>boot(event.target));document.addEventListener('shopify:section:unload',event=>{event.target.querySelectorAll('[data-fv-gift]').forEach(root=>root.fvgObserver?.disconnect())});document.addEventListener('shopify:block:select',event=>{const root=event.target.closest('[data-fv-gift]');if(root)root.querySelectorAll('[data-fvg-reveal]').forEach(node=>node.classList.add('is-visible'))})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
(function () {
  var galleriesV7 = new WeakMap();
  var selector = '.fv-product-shell[data-fv-page]';

  function findRoots(scope) {
    var roots = [];
    if (scope.matches && scope.matches(selector)) roots.push(scope);
    if (scope.querySelectorAll) roots = roots.concat(Array.from(scope.querySelectorAll(selector)));
    return roots;
  }

  function initialize(root) {
    if (galleriesV7.has(root)) return;
    var section = root.querySelector('[data-section-type="product"]');
    if (!section) return;
    var thumbnails = Array.from(root.querySelectorAll('[data-fv-thumbnail]'));
    var wrappers = Array.from(section.querySelectorAll('[data-product-single-media-wrapper]'));
    var controller = new AbortController();
    var signal = controller.signal;
    var previous = root.querySelector('[data-fv-prev]');
    var next = root.querySelector('[data-fv-next]');
    var count = root.querySelector('[data-fv-count]');
    var stage = root.querySelector('[data-fv-stage]');
    var zoom = root.querySelector('[data-fv-zoom]');
    var dialog = root.querySelector('dialog[data-fv-dialog]');
    var dialogImage = root.querySelector('[data-fv-dialog-image]');
    var dialogCaption = root.querySelector('[data-fv-dialog-caption]');
    var dialogCount = root.querySelector('[data-fv-dialog-count]');
    var dialogViewport = root.querySelector('[data-fv-dialog-viewport]');
    var dialogFit = root.querySelector('[data-fv-dialog-fit]');
    var dialogItems = [];
    var dialogIndex = 0;
    var zoomed = false;
    var currentIndex = 0;
    var lastFocus = null;
    var swipe = null;
    var dialogSwipe = null;
    var suppressDialogClickUntil = 0;
    var photoAnimations = new Set();
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function centerThumbnail(button) {
      var parent = button.parentElement;
      while (parent && parent !== root) {
        var overflow = window.getComputedStyle(parent).overflowX;
        if (parent.scrollWidth > parent.clientWidth + 1 && (overflow === 'auto' || overflow === 'scroll')) {
          var buttonBounds = button.getBoundingClientRect();
          var parentBounds = parent.getBoundingClientRect();
          var left = parent.scrollLeft + buttonBounds.left - parentBounds.left - (parent.clientWidth - buttonBounds.width) / 2;
          parent.scrollTo({ left: left, behavior: reducedMotion.matches || root.getAttribute('data-fv-animations') === 'false' ? 'auto' : 'smooth' });
          return;
        }
        parent = parent.parentElement;
      }
    }

    function synchronize(mediaId, scroll) {
      var index = thumbnails.findIndex(function (button) {
        return button.getAttribute('data-thumbnail-id') === mediaId;
      });
      if (index < 0) return;
      currentIndex = index;
      thumbnails.forEach(function (button, buttonIndex) {
        button.classList.toggle('is-selected', buttonIndex === index);
        if (buttonIndex === index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      if (count) count.textContent = (index + 1) + ' / ' + thumbnails.length;
      if (previous) previous.disabled = thumbnails.length < 2;
      if (next) next.disabled = thumbnails.length < 2;
      if (zoom) {
        zoom.hidden = thumbnails[index].getAttribute('data-fv-media-type') !== 'image' || !thumbnails[index].getAttribute('data-fv-full-src') || !dialog || !dialogImage || typeof dialog.showModal !== 'function';
      }
      if (scroll) centerThumbnail(thumbnails[index]);
    }

    function switchTo(index, focusThumbnail) {
      if (!thumbnails.length || !wrappers.length) return;
      var normalized = (index + thumbnails.length) % thumbnails.length;
      var button = thumbnails[normalized];
      var mediaId = button.getAttribute('data-thumbnail-id');
      var target = wrappers.find(function (wrapper) {
        return wrapper.getAttribute('data-media-id') === mediaId;
      });
      if (!target) return;
      var active = wrappers.find(function (wrapper) {
        return !wrapper.classList.contains('hide');
      });
      if (active !== target) {
        if (active) active.dispatchEvent(new CustomEvent('mediaHidden', { bubbles: true, cancelable: true }));
        wrappers.forEach(function (wrapper) {
          wrapper.classList.toggle('hide', wrapper !== target);
        });
        target.dispatchEvent(new CustomEvent('mediaVisible', { bubbles: true, cancelable: true }));
      }
      synchronize(mediaId, true);
      if (focusThumbnail) button.focus({ preventScroll: true });
    }

    function setZoomed(value) {
      zoomed = Boolean(value);
      if (dialogViewport) {
        dialogViewport.classList.toggle('is-zoomed', zoomed);
        dialogViewport.scrollTo({left: 0, top: 0, behavior: 'auto'});
      }
      if (dialogFit) {
        dialogFit.setAttribute('aria-pressed', String(zoomed));
        var label = dialogFit.getAttribute(zoomed ? 'data-fv-fit-label' : 'data-fv-zoom-label');
        if (label) dialogFit.textContent = label;
      }
    }

    function showDialogPhoto(index, synchronizeGallery) {
      if (!dialogItems.length || !dialogImage) return;
      dialogIndex = (index + dialogItems.length) % dialogItems.length;
      var item = dialogItems[dialogIndex];
      setZoomed(false);
      photoAnimations.forEach(function (animation) { animation.cancel(); });
      dialog.classList.add('is-loading');
      dialog.classList.remove('is-image-error');
      if (dialogViewport) dialogViewport.setAttribute('aria-busy', 'true');
      dialogImage.src = item.source;
      dialogImage.alt = item.alt;
      if (dialogCaption) dialogCaption.textContent = item.alt;
      if (dialogCount) dialogCount.textContent = (dialogIndex + 1) + ' / ' + dialogItems.length;
      var onlyOne = dialogItems.length < 2;
      dialog.querySelectorAll('[data-fv-dialog-prev],[data-fv-dialog-next]').forEach(function (button) { button.disabled = onlyOne; });
      if (synchronizeGallery && item.thumbnailIndex !== undefined) switchTo(item.thumbnailIndex, false);
      if (dialogImage.complete && dialogImage.naturalWidth > 0) finishDialogImage();
    }

    function finishDialogImage() {
      if (!dialog || !dialogImage || !dialog.classList.contains('is-loading')) return;
      dialog.classList.remove('is-loading');
      if (dialogViewport) dialogViewport.removeAttribute('aria-busy');
      if (!reducedMotion.matches && root.getAttribute('data-fv-animations') !== 'false' && typeof dialogImage.animate === 'function') {
        var animation = dialogImage.animate([{ opacity: 0.55 }, { opacity: 1 }], { duration: 190, easing: 'ease-out' });
        photoAnimations.add(animation);
        animation.finished.then(function () { photoAnimations.delete(animation); }, function () { photoAnimations.delete(animation); });
      }
    }

    function openDialog(items, index) {
      if (!dialog || !dialogImage || typeof dialog.showModal !== 'function' || dialog.open || !items.length) return;
      lastFocus = document.activeElement;
      dialogItems = items;
      showDialogPhoto(index, false);
      dialog.showModal();
      var close = dialog.querySelector('[data-fv-dialog-close]');
      if (close) close.focus({preventScroll:true});
    }

    function openZoom() {
      var selected = thumbnails[currentIndex];
      if (!selected || selected.getAttribute('data-fv-media-type') !== 'image') return;
      var items = thumbnails.map(function (button, index) { return {source:button.getAttribute('data-fv-full-src'),alt:button.getAttribute('data-fv-alt') || '',thumbnailIndex:index,type:button.getAttribute('data-fv-media-type')}; }).filter(function (item) { return item.type === 'image' && item.source; });
      var index = items.findIndex(function (item) { return item.thumbnailIndex === currentIndex; });
      openDialog(items, Math.max(0,index));
    }

    root.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var editorial = event.target.closest('[data-fv-editorial-zoom]');
      if (editorial && (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0)) return;
      if (editorial && root.contains(editorial) && dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        var links = Array.from(root.querySelectorAll('[data-fv-editorial-zoom]'));
        var group = editorial.getAttribute('data-fv-zoom-group');
        if (group) links = links.filter(function (link) { return link.getAttribute('data-fv-zoom-group') === group; });
        openDialog(links.map(function (link) { return {source:link.href,alt:link.getAttribute('data-fv-alt') || ''}; }),links.indexOf(editorial));
        return;
      }
      if (dialog && dialog.open && event.target.closest('[data-fv-dialog-prev]')) { event.preventDefault(); showDialogPhoto(dialogIndex - 1,true); return; }
      if (dialog && dialog.open && event.target.closest('[data-fv-dialog-next]')) { event.preventDefault(); showDialogPhoto(dialogIndex + 1,true); return; }
      if (dialog && dialog.open && (event.target.closest('[data-fv-dialog-fit]') || event.target === dialogImage)) {
        event.preventDefault();
        if (event.target === dialogImage && performance.now() < suppressDialogClickUntil) return;
        setZoomed(!zoomed);
        return;
      }
      var button = event.target.closest('[data-fv-thumbnail]');
      if (button && root.contains(button)) {
        event.preventDefault();
        switchTo(thumbnails.indexOf(button), false);
        return;
      }
      if (event.target.closest('[data-fv-prev]')) {
        event.preventDefault();
        switchTo(currentIndex - 1, false);
      } else if (event.target.closest('[data-fv-next]')) {
        event.preventDefault();
        switchTo(currentIndex + 1, false);
      } else if (event.target.closest('[data-fv-zoom]')) {
        event.preventDefault();
        openZoom();
      } else if (event.target.closest('[data-fv-dialog-close]') && dialog) {
        event.preventDefault();
        dialog.close();
      }
    }, { signal: signal });

    root.addEventListener('keydown', function (event) {
      if (!(event.target instanceof Element)) return;
      var button = event.target.closest('[data-fv-thumbnail]');
      if (!button) return;
      var index = thumbnails.indexOf(button);
      if (index < 0) return;
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        switchTo(index + 1, true);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        switchTo(index - 1, true);
      } else if (event.key === 'Home') {
        event.preventDefault();
        switchTo(0, true);
      } else if (event.key === 'End') {
        event.preventDefault();
        switchTo(thumbnails.length - 1, true);
      }
    }, { signal: signal });

    section.addEventListener('mediaVisible', function (event) {
      if (!(event.target instanceof Element)) return;
      var wrapper = event.target.closest('[data-product-single-media-wrapper]');
      if (wrapper) synchronize(wrapper.getAttribute('data-media-id'), true);
    }, { signal: signal });

    if (stage) {
      stage.addEventListener('pointerdown', function (event) {
        swipe = null;
        if (event.pointerType !== 'touch' || !event.isPrimary || !thumbnails[currentIndex] || thumbnails[currentIndex].getAttribute('data-fv-media-type') !== 'image' || !(event.target instanceof Element)) return;
        var wrapper = event.target.closest('[data-product-single-media-wrapper]');
        if (!wrapper || wrapper.classList.contains('hide') || !event.target.closest('.fv-main-photo, .product-single__media') || event.target.closest('button,a,input')) return;
        swipe = { id: event.pointerId, x: event.clientX, y: event.clientY, time: performance.now(), index: currentIndex };
      }, { signal: signal, passive: true });
      stage.addEventListener('pointerup', function (event) {
        var start = swipe;
        swipe = null;
        if (!start || start.id !== event.pointerId || start.index !== currentIndex || performance.now() - start.time > 1000) return;
        var horizontal = event.clientX - start.x;
        var vertical = event.clientY - start.y;
        if (Math.abs(horizontal) >= 40 && Math.abs(horizontal) > Math.abs(vertical) * 1.35) switchTo(currentIndex + (horizontal < 0 ? 1 : -1), false);
      }, { signal: signal, passive: true });
      stage.addEventListener('pointercancel', function () {
        swipe = null;
      }, { signal: signal, passive: true });
    }

    if (dialog) {
      dialog.addEventListener('keydown', function (event) {
        if (event.ctrlKey || event.metaKey || event.altKey) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          showDialogPhoto(dialogIndex + (event.key === 'ArrowRight' ? 1 : -1),true);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          showDialogPhoto(event.key === 'Home' ? 0 : dialogItems.length - 1, true);
        }
      }, {signal:signal});
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }, { signal: signal });
      dialog.addEventListener('close', function () {
        setZoomed(false);
        dialog.classList.remove('is-loading', 'is-image-error');
        if (dialogViewport) dialogViewport.removeAttribute('aria-busy');
        photoAnimations.forEach(function (animation) { animation.cancel(); });
        if (lastFocus && lastFocus.isConnected && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
        lastFocus = null;
      }, { signal: signal });
    }

    if (dialogImage) {
      dialogImage.addEventListener('load', finishDialogImage, { signal: signal });
      dialogImage.addEventListener('error', function () {
        if (!dialog) return;
        dialog.classList.remove('is-loading');
        dialog.classList.add('is-image-error');
        if (dialogViewport) dialogViewport.removeAttribute('aria-busy');
      }, { signal: signal });
    }

    reducedMotion.addEventListener('change', function () {
      if (reducedMotion.matches) photoAnimations.forEach(function (animation) { animation.cancel(); });
    }, { signal: signal });

    if (dialogViewport) {
      dialogViewport.addEventListener('pointerdown', function (event) {
        dialogSwipe = null;
        if (event.pointerType !== 'touch' || !event.isPrimary || zoomed || dialogItems.length < 2 || !(event.target instanceof Element) || event.target.closest('button,a,input')) return;
        dialogSwipe = { id: event.pointerId, x: event.clientX, y: event.clientY, time: performance.now() };
      }, { signal: signal, passive: true });
      dialogViewport.addEventListener('pointerup', function (event) {
        var start = dialogSwipe;
        dialogSwipe = null;
        if (!start || start.id !== event.pointerId || zoomed || performance.now() - start.time > 1000) return;
        var horizontal = event.clientX - start.x;
        var vertical = event.clientY - start.y;
        if (Math.abs(horizontal) >= 48 && Math.abs(horizontal) > Math.abs(vertical) * 1.35) {
          suppressDialogClickUntil = performance.now() + 350;
          showDialogPhoto(dialogIndex + (horizontal < 0 ? 1 : -1), true);
        }
      }, { signal: signal, passive: true });
      dialogViewport.addEventListener('pointercancel', function () { dialogSwipe = null; }, { signal: signal, passive: true });
    }

    var active = wrappers.find(function (wrapper) {
      return !wrapper.classList.contains('hide');
    });
    if (thumbnails.length) synchronize(active ? active.getAttribute('data-media-id') : thumbnails[0].getAttribute('data-thumbnail-id'), false);
    else {
      if (zoom) zoom.hidden = true;
      if (previous) previous.disabled = true;
      if (next) next.disabled = true;
    }
    galleriesV7.set(root, { controller: controller, dialog: dialog, animations: photoAnimations });
  }

  function initializeWithin(scope) {
    findRoots(scope).forEach(initialize);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    findRoots(event.target).forEach(function (root) {
      var gallery = galleriesV7.get(root);
      if (!gallery) return;
      gallery.controller.abort();
      gallery.animations.forEach(function (animation) { animation.cancel(); });
      if (gallery.dialog && gallery.dialog.open) gallery.dialog.close();
      galleriesV7.delete(root);
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeWithin(document);
    }, { once: true });
  } else {
    initializeWithin(document);
  }
}());

(function () {
  var selector = '.fv-product-shell[data-fv-page]';
  var experiencesV7 = new WeakMap();

  function findRoots(scope) {
    var roots = [];
    if (scope.matches && scope.matches(selector)) roots.push(scope);
    if (scope.querySelectorAll) roots = roots.concat(Array.from(scope.querySelectorAll(selector)));
    return roots;
  }

  function initialize(root) {
    if (experiencesV7.has(root)) return;
    var controller = new AbortController();
    var signal = controller.signal;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var nav = root.querySelector('[data-fv-nav]');
    var links = Array.from(root.querySelectorAll('[data-fv-nav-link]'));
    var sections = Array.from(root.querySelectorAll('[data-fv-section][id]'));
    var progress = root.querySelector('[data-fv-progress]');
    var buybar = root.querySelector('[data-fv-sticky-buy]');
    var buyAction = root.querySelector('[data-fv-buy-action]');
    var buyObserver = root.querySelector('[data-fv-buy-observer]');
    var form = root.querySelector('[data-product-form]');
    var originalButton = form && form.querySelector('[data-add-to-cart]');
    var price = root.querySelector('[data-price]');
    var stickyPrice = root.querySelector('[data-fv-sticky-price]');
    var stickyCompare = root.querySelector('[data-fv-sticky-compare]');
    var hero = root.querySelector('[data-fv-hero]');
    var footer = document.querySelector('.site-footer');
    var cartPopup = document.querySelector('[data-cart-popup-wrapper]');
    var revealItems = Array.from(root.querySelectorAll('[data-fv-reveal]')).filter(function (item) {
      return item !== hero && !(form && item.contains(form)) && !item.closest('[data-product-form], [data-fv-stage], [data-fv-sticky-buy], dialog');
    });
    var photoItems = Array.from(root.querySelectorAll('[data-fv-reveal-photo]')).filter(function (item) {
      return !item.closest('[data-fv-hero], [data-product-form], [data-fv-stage], [data-fv-sticky-buy], dialog');
    });
    var revealSet = new Set(revealItems);
    var photoSet = new Set(photoItems);
    var motionClasses = [];
    var motionStyles = [];
    var motionAttributes = [];
    var staggerChildren = [];
    var revealObserver = null;
    var resizeObserver = null;
    var stateObserver = null;
    var overlayObserver = null;
    var frame = 0;
    var framePrice = 0;
    var activeId = null;
    var navHeight = 0;
    var headerOffset = 0;
    var animations = new Set();
    var detailsAnimations = new WeakMap();
    var defaultBuyLabel = buyAction && (buyAction.getAttribute('data-fv-default-buy-label') || buyAction.textContent.trim());
    var destroy = null;

    function rememberClasses(element, names) {
      names.forEach(function (name) {
        motionClasses.push({ element: element, name: name, present: element.classList.contains(name) });
      });
    }

    function prepareMotion() {
      revealItems.forEach(function (item, index) {
        var direction = item.getAttribute('data-fv-reveal');
        if (direction === '' || direction === 'auto') {
          motionAttributes.push({ element: item, name: 'data-fv-reveal', value: direction });
          item.setAttribute('data-fv-reveal', index % 2 === 0 ? 'right' : 'left');
        }
        item.querySelectorAll('.fv-fine-rule').forEach(function (rule) {
          if (rule.closest('[data-fv-reveal]') !== item) return;
          rememberClasses(rule, ['fv-rule-ready']);
          rule.classList.add('fv-rule-ready');
        });
      });
      root.querySelectorAll('.fv-benefit-grid,.fv-craft-grid,.fv-steps-grid,.fv-editorial-gallery__grid,.fv-gallery__grid,[data-fv-stagger-group]').forEach(function (group) {
        Array.from(group.children).filter(function (item) { return revealSet.has(item); }).forEach(function (item, index) {
          motionStyles.push({ element: item, name: '--fv-delay', value: item.style.getPropertyValue('--fv-delay'), priority: item.style.getPropertyPriority('--fv-delay') });
          item.style.setProperty('--fv-delay', Math.min(index, 3) * 60 + 'ms');
        });
      });
      photoItems.forEach(function (item) { item.classList.add('fv-visual-ready'); });
    }

    function prepareTextStagger() {
      revealItems.forEach(function (item) {
        var candidates = Array.from(item.querySelectorAll('[data-fv-stagger] > h1,[data-fv-stagger] > h2,[data-fv-stagger] > h3,[data-fv-stagger] > h4,[data-fv-stagger] > p,[data-fv-stagger] > ul,[data-fv-stagger] > ol,[data-fv-stagger] > blockquote,.rte > p,.rte > ul,.rte > ol,.rte > h2,.rte > h3,.rte > blockquote'));
        Array.from(item.children).forEach(function (child) {
          if (child.matches('h1,h2,h3,h4,p,ul,ol,blockquote')) candidates.push(child);
        });
        candidates.filter(function (child, index, list) {
          return list.indexOf(child) === index && child.closest('[data-fv-reveal]') === item;
        }).sort(function (first, second) {
          return first.compareDocumentPosition(second) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
        }).forEach(function (child, index) {
          staggerChildren.push({ element: child, delay: child.style.getPropertyValue('--fv-reveal-delay'), className: child.classList.contains('fv-stagger-child') });
          child.classList.add('fv-stagger-child');
          child.style.setProperty('--fv-reveal-delay', Math.min(index, 4) * 45 + 'ms');
        });
      });
    }

    function reveal(item) {
      item.classList.remove('fv-reveal-pending');
      item.classList.add('is-revealed');
      if (revealObserver) revealObserver.unobserve(item);
    }

    function revealPhoto(item) {
      item.classList.add('is-visual-revealed');
      if (revealObserver) revealObserver.unobserve(item);
    }

    function revealWithin(scope) {
      revealItems.forEach(function (item) {
        if (item === scope || scope.contains(item) || item.contains(scope)) reveal(item);
      });
      photoItems.forEach(function (item) {
        if (item === scope || scope.contains(item) || item.contains(scope)) revealPhoto(item);
      });
    }

    function revealAll() {
      revealItems.forEach(reveal);
      photoItems.forEach(revealPhoto);
      if (revealObserver) revealObserver.disconnect();
      root.classList.remove('fv-motion-ready');
    }

    function animate(element, keyframes, options) {
      if ((reducedMotion.matches || root.getAttribute('data-fv-animations') === 'false') || typeof element.animate !== 'function') return null;
      var animation = element.animate(keyframes, options);
      animations.add(animation);
      animation.finished.then(function () {
        animations.delete(animation);
      }, function () {
        animations.delete(animation);
      });
      return animation;
    }

    function targetFor(link) {
      if (!link.hash) return null;
      var id;
      try {
        id = decodeURIComponent(link.hash.slice(1));
      } catch (error) {
        return null;
      }
      var target = document.getElementById(id);
      return target && root.contains(target) ? target : null;
    }

    function measure() {
      navHeight = nav && !nav.hidden ? nav.getBoundingClientRect().height : 0;
      var header = document.querySelector('.site-header');
      headerOffset = 0;
      if (header) {
        var position = window.getComputedStyle(header).position;
        var bounds = header.getBoundingClientRect();
        if ((position === 'fixed' || position === 'sticky') && bounds.top <= 1 && bounds.bottom > 0) headerOffset = Math.max(0, bounds.bottom);
      }
      root.style.setProperty('--fv-nav-height', Math.ceil(navHeight) + 'px');
      root.style.setProperty('--fv-header-offset', Math.ceil(headerOffset) + 'px');
    }

    function centerLink(link) {
      if (!nav || !link) return;
      var parent = link.parentElement;
      while (parent && root.contains(parent)) {
        var overflow = window.getComputedStyle(parent).overflowX;
        if (parent.scrollWidth > parent.clientWidth + 1 && (overflow === 'auto' || overflow === 'scroll')) {
          var bounds = parent.getBoundingClientRect();
          var linkBounds = link.getBoundingClientRect();
          var left = parent.scrollLeft + linkBounds.left - bounds.left - (parent.clientWidth - linkBounds.width) / 2;
          parent.scrollTo({ left: left, behavior: (reducedMotion.matches || root.getAttribute('data-fv-animations') === 'false') ? 'auto' : 'smooth' });
          break;
        }
        if (parent === nav) break;
        parent = parent.parentElement;
      }
    }

    function setActive(id) {
      if (activeId === id) return;
      activeId = id;
      var activeLink = null;
      links.forEach(function (link) {
        var target = targetFor(link);
        var isActive = Boolean(target && target.id === id);
        link.classList.toggle('is-current', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'location');
          activeLink = link;
        } else {
          link.removeAttribute('aria-current');
        }
      });
      centerLink(activeLink);
    }

    function overlayIsOpen() {
      return document.body.classList.contains('js-drawer-open') ||
        document.body.classList.contains('prevent-scrolling') ||
        Boolean(root.querySelector('dialog[open]')) || Boolean(document.querySelector('.js-mobile-nav-toggle[aria-expanded="true"]')) ||
        Boolean(cartPopup && !cartPopup.classList.contains('cart-popup-wrapper--hidden'));
    }

    function setBuybarVisible(visible) {
      if (!buybar) return;
      buybar.classList.toggle('is-visible', visible);
      buybar.hidden = !visible;
      if (visible) buybar.removeAttribute('aria-hidden');
      else buybar.setAttribute('aria-hidden', 'true');
    }

    function updateScroll() {
      frame = 0;
      if (!root.isConnected) return;
      var rootBounds = root.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      var offset = headerOffset + navHeight + 32;
      var currentSection = sections[0];
      sections.forEach(function (section) {
        if (section.getBoundingClientRect().top <= offset) currentSection = section;
      });
      if (currentSection) setActive(currentSection.id);
      if (progress) {
        var total = Math.max(1, rootBounds.height - viewportHeight);
        var fraction = Math.min(1, Math.max(0, -rootBounds.top / total));
        progress.style.transform = 'scaleX(' + fraction.toFixed(4) + ')';
      }
      var hasOverlay = overlayIsOpen();
      root.classList.toggle('fv-overlay-open', hasOverlay);
      if (buybar && buyObserver && originalButton) {
        var buyBounds = buyObserver.getBoundingClientRect();
        var heroBounds = hero && hero.getBoundingClientRect();
        var footerBounds = footer && footer.getBoundingClientRect();
        var pastBuy = buyBounds.bottom < headerOffset + navHeight;
        var pastHeroStart = !heroBounds || heroBounds.top < 0;
        var inPage = rootBounds.bottom > Math.max(120, buybar.getBoundingClientRect().height + 72);
        var atFooter = Boolean(footerBounds && footerBounds.top < viewportHeight && footerBounds.bottom > 0);
        setBuybarVisible(pastBuy && pastHeroStart && inPage && !atFooter && !hasOverlay);
      }
    }

    function scheduleScroll() {
      if (!frame) frame = window.requestAnimationFrame(updateScroll);
    }

    function updatePurchaseState() {
      framePrice = 0;
      if (stickyPrice && price) {
        var priceUnavailable = price.classList.contains('price--unavailable') || price.getAttribute('aria-hidden') === 'true';
        stickyPrice.hidden = priceUnavailable;
        var currentPrice = price.classList.contains('price--on-sale') ? price.querySelector('[data-sale-price]') : price.querySelector('.price__regular [data-regular-price]');
        if (currentPrice) stickyPrice.textContent = currentPrice.textContent.trim();
        if (stickyCompare) {
          var compare = price.querySelector('.price__sale [data-regular-price]');
          var showCompare = !priceUnavailable && price.classList.contains('price--on-sale') && compare;
          stickyCompare.hidden = !showCompare;
          stickyCompare.textContent = showCompare ? compare.textContent.trim() : '';
        }
      }
      if (buyAction && originalButton) {
        var originalText = originalButton.querySelector('[data-add-to-cart-text]');
        var available = !originalButton.disabled && originalButton.getAttribute('aria-disabled') !== 'true';
        var soldOut = form && form.classList.contains('product-form--variant-sold-out');
        var busy = !available && !soldOut;
        var label = available || busy ? defaultBuyLabel : (originalButton.getAttribute('aria-label') || (originalText ? originalText.textContent.trim() : originalButton.textContent.trim()));
        var labelNode = buyAction.querySelector('[data-fv-buy-label]');
        if (labelNode) labelNode.textContent = label || defaultBuyLabel;
        else buyAction.textContent = label || defaultBuyLabel;
        buyAction.disabled = Boolean(busy);
        if (busy) buyAction.setAttribute('aria-busy', 'true');
        else buyAction.removeAttribute('aria-busy');
        if (buybar) buybar.classList.toggle('is-unavailable', !available && !busy);
      }
      scheduleScroll();
    }

    function schedulePurchaseState() {
      if (!framePrice) framePrice = window.requestAnimationFrame(updatePurchaseState);
    }

    function moveTo(target, focusTarget, remember) {
      if (!target) return;
      revealWithin(target);
      measure();
      var top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerOffset - navHeight - 20);
      if (focusTarget) {
        var temporaryTabIndex = !focusTarget.hasAttribute('tabindex') && !focusTarget.matches('a[href],button,input,select,textarea');
        if (temporaryTabIndex) {
          focusTarget.setAttribute('tabindex', '-1');
          focusTarget.addEventListener('blur', function () {
            focusTarget.removeAttribute('tabindex');
          }, { once: true, signal: signal });
        }
        focusTarget.focus({ preventScroll: true });
      }
      window.scrollTo({ top: top, behavior: (reducedMotion.matches || root.getAttribute('data-fv-animations') === 'false') ? 'auto' : 'smooth' });
      if (remember && target.id) {
        var hash = '#' + encodeURIComponent(target.id);
        if (window.location.hash !== hash) window.history.pushState(null, '', hash);
        setActive(target.id);
      }
    }

    root.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var link = event.target.closest('[data-fv-nav-link], [data-fv-anchor]');
      if (link && root.contains(link) && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0 && (!link.target || link.target === '_self')) {
        var target = targetFor(link);
        if (target) {
          event.preventDefault();
          moveTo(target, target, true);
        }
      }
      if (buyAction && (event.target === buyAction || buyAction.contains(event.target))) {
        event.preventDefault();
        if (!form || !originalButton || buyAction.disabled) return;
        var hasVariants = root.getAttribute('data-fv-has-variants') === 'true';
        var available = !originalButton.disabled && originalButton.getAttribute('aria-disabled') !== 'true';
        if (!hasVariants && root.getAttribute('data-fv-has-variants') === 'false' && available) {
          originalButton.click();
        } else {
          var option = form.querySelector('.single-option-selector:not([disabled]), select[name="id"]:not(.no-js):not([disabled]), input[type="radio"]:not([disabled])');
          var buyTarget = buyObserver || form;
          moveTo(buyTarget, hasVariants && option ? option : originalButton, false);
        }
      }
    }, { signal: signal });

    root.addEventListener('toggle', function (event) {
      var details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.matches('.fv-details, [data-fv-accordion]')) return;
      var existing = detailsAnimations.get(details);
      if (existing) existing.cancel();
      if (!details.open) return;
      var content = Array.from(details.children).find(function (child) {
        return child.tagName !== 'SUMMARY';
      });
      if (!content) return;
      revealWithin(details);
      var animation = animate(content, [{ opacity: 0, transform: 'translateY(-5px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 240, easing: 'cubic-bezier(.2,.65,.3,1)' });
      if (animation) detailsAnimations.set(details, animation);
      scheduleScroll();
    }, { capture: true, signal: signal });

    root.addEventListener('mediaVisible', function (event) {
      if (!(event.target instanceof Element)) return;
      var image = event.target.querySelector('.fv-main-photo');
      if (image) animate(image, [{ opacity: 0.65 }, { opacity: 1 }], { duration: 240, easing: 'ease-out' });
    }, { signal: signal });

    window.addEventListener('scroll', scheduleScroll, { passive: true, signal: signal });
    window.addEventListener('resize', function () {
      measure();
      scheduleScroll();
    }, { passive: true, signal: signal });
    window.addEventListener('pageshow', function () {
      measure();
      schedulePurchaseState();
    }, { signal: signal });
    window.addEventListener('hashchange', function () {
      var id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (error) { return; }
      var target = document.getElementById(id);
      if (target && root.contains(target)) revealWithin(target);
      scheduleScroll();
    }, { signal: signal });
    reducedMotion.addEventListener('change', function () {
      if ((reducedMotion.matches || root.getAttribute('data-fv-animations') === 'false')) {
        revealAll();
        animations.forEach(function (animation) { animation.cancel(); });
      }
      scheduleScroll();
    }, { signal: signal });

    rememberClasses(root, ['fv-motion-ready', 'fv-overlay-open']);
    revealItems.forEach(function (item) { rememberClasses(item, ['fv-reveal-pending', 'is-revealed']); });
    photoItems.forEach(function (item) { rememberClasses(item, ['fv-visual-ready', 'is-visual-revealed']); });
    ['--fv-nav-height', '--fv-header-offset'].forEach(function (name) {
      motionStyles.push({ element: root, name: name, value: root.style.getPropertyValue(name), priority: root.style.getPropertyPriority(name) });
    });

    if (typeof window.IntersectionObserver === 'function' && !(reducedMotion.matches || root.getAttribute('data-fv-animations') === 'false') && !(window.Shopify && window.Shopify.designMode)) {
      prepareMotion();
      prepareTextStagger();
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (revealSet.has(entry.target)) reveal(entry.target);
          if (photoSet.has(entry.target)) revealPhoto(entry.target);
        });
      }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
      revealItems.forEach(function (item) {
        if (item.getBoundingClientRect().bottom <= 0 || item.matches(':focus-within')) reveal(item);
        else {
          item.classList.add('fv-reveal-pending');
          revealObserver.observe(item);
        }
      });
      photoItems.forEach(function (item) {
        if (item.getBoundingClientRect().bottom <= 0 || item.matches(':focus-within')) revealPhoto(item);
        else revealObserver.observe(item);
      });
      root.classList.add('fv-motion-ready');
      root.addEventListener('focusin', function (event) {
        var item = event.target instanceof Element && event.target.closest('[data-fv-reveal], [data-fv-reveal-photo]');
        if (item && root.contains(item)) revealWithin(item);
      }, { signal: signal });
    } else {
      revealAll();
    }

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(function () {
        measure();
        scheduleScroll();
      });
      resizeObserver.observe(root);
      if (nav) resizeObserver.observe(nav);
      if (buyObserver) resizeObserver.observe(buyObserver);
    }

    if ('MutationObserver' in window) {
      stateObserver = new MutationObserver(schedulePurchaseState);
      if (price) stateObserver.observe(price, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'aria-hidden'] });
      if (originalButton) stateObserver.observe(originalButton, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'aria-disabled', 'disabled', 'class'] });
      if (form) stateObserver.observe(form, { attributes: true, attributeFilter: ['class'] });
      overlayObserver = new MutationObserver(function () {
        if (root.getAttribute('data-fv-animations') === 'false') {
          revealAll();
          animations.forEach(function (animation) { animation.cancel(); });
        }
        scheduleScroll();
      });
      overlayObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      overlayObserver.observe(root, { attributes: true, attributeFilter: ['open', 'data-fv-animations'], subtree: true });
      var mobileToggle = document.querySelector('.js-mobile-nav-toggle'); if (mobileToggle) overlayObserver.observe(mobileToggle,{attributes:true,attributeFilter:['aria-expanded']});
      if (cartPopup) overlayObserver.observe(cartPopup, { attributes: true, attributeFilter: ['class'] });
    }

    destroy = function () {
      controller.abort();
      if (frame) window.cancelAnimationFrame(frame);
      if (framePrice) window.cancelAnimationFrame(framePrice);
      if (revealObserver) revealObserver.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      if (stateObserver) stateObserver.disconnect();
      if (overlayObserver) overlayObserver.disconnect();
      animations.forEach(function (animation) { animation.cancel(); });
      revealAll();
      staggerChildren.forEach(function (record) {
        if (!record.className) record.element.classList.remove('fv-stagger-child');
        if (record.delay) record.element.style.setProperty('--fv-reveal-delay', record.delay);
        else record.element.style.removeProperty('--fv-reveal-delay');
      });
      motionStyles.forEach(function (record) {
        if (record.value) record.element.style.setProperty(record.name, record.value, record.priority);
        else record.element.style.removeProperty(record.name);
      });
      motionAttributes.forEach(function (record) { record.element.setAttribute(record.name, record.value); });
      motionClasses.forEach(function (record) { record.element.classList.toggle(record.name, record.present); });
      setBuybarVisible(false);
      experiencesV7.delete(root);
    };
    experiencesV7.set(root, { destroy: destroy, revealWithin: revealWithin });
    measure();
    updatePurchaseState();
    updateScroll();
  }

  function initializeWithin(scope) {
    findRoots(scope).forEach(initialize);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    findRoots(event.target).forEach(function (root) {
      var experience = experiencesV7.get(root);
      if (experience) experience.destroy();
    });
  });
  document.addEventListener('shopify:block:select', function (event) {
    if (!(event.target instanceof Element)) return;
    var root = event.target.closest(selector);
    var experience = root && experiencesV7.get(root);
    if (experience) experience.revealWithin(event.target);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeWithin(document);
    }, { once: true });
  } else {
    initializeWithin(document);
  }
}());


(function () {
  'use strict';
  var selector = '.fv-product-shell[data-fv-page]';
  var instances = new WeakMap();
  function roots(scope) {
    var found = [];
    if (scope.matches && scope.matches(selector)) found.push(scope);
    if (scope.querySelectorAll) found = found.concat(Array.from(scope.querySelectorAll(selector)));
    return found;
  }
  function read(node) {
    try {
      var value = JSON.parse(node.textContent);
      if (!value.productId || !value.sectionId || !Array.isArray(value.variants)) return null;
      var rows = new Map();
      value.variants.forEach(function (item) {
        if (item.id && typeof item.available === 'boolean' && ['in', 'available', 'out', 'backorder'].indexOf(item.state) !== -1) rows.set(String(item.id), item);
      });
      if (!rows.size) return null;
      return { data: value, rows: rows };
    } catch (error) { return null; }
  }
  function initialize(root) {
    if (instances.has(root)) return;
    var container = root.querySelector('[data-section-type="product"]');
    var script = root.querySelector('script[data-fv-commerce-data]');
    var parsed = script && read(script);
    var pill = root.querySelector('[data-fv-stock]');
    var label = pill && pill.querySelector('[data-fv-stock-label]');
    if (!container || !parsed || !pill || !label) return;
    var data = parsed.data;
    var rows = parsed.rows;
    var freshRows = new Map();
    var nativeVariants = new Map();
    var selectedId = data.initialVariantId ? String(data.initialVariantId) : null;
    var controller = new AbortController();
    var signal = controller.signal;
    var pending = null;
    var timer = 0;
    var debounce = 0;
    var timeout = 0;
    var retry = 0;
    var sequence = 0;
    var stopped = false;
    var pendingSync = false;
    var loader = container.querySelector('[data-add-to-cart] [data-loader]');
    var loaderObserver = null;
    var seed = root.querySelector('[id="ProductJson-' + data.sectionId + '"]');
    if (seed) {
      try { JSON.parse(seed.textContent).variants.forEach(function (variant) { nativeVariants.set(String(variant.id), variant); }); } catch (error) {}
    }
    function usable() {
      return !stopped && root.isConnected && data.live === true && /^https?:$/.test(window.location.protocol) && document.visibilityState !== 'hidden' && navigator.onLine !== false && !(window.Shopify && window.Shopify.designMode);
    }
    function render() {
      var row = selectedId && rows.get(selectedId);
      var state = row ? (row.available ? row.state : 'out') : 'missing';
      var text = { in: data.inLabel, available: data.availableLabel, out: data.outLabel, backorder: data.backorderLabel, missing: data.missingLabel }[state];
      var target = state === 'in' || state === 'available' ? '#' + data.buyId : data.contactUrl;
      if (label.textContent !== text) label.textContent = text || '';
      if (pill.getAttribute('data-state') !== state) pill.setAttribute('data-state', state);
      if (target && pill.getAttribute('href') !== target) pill.setAttribute('href', target);
    }
    function syncNative() {
      var row = selectedId && freshRows.get(selectedId);
      var variant = selectedId && nativeVariants.get(selectedId);
      if (!row || !variant || (!pendingSync && variant.available === row.available)) return;
      if (loader && !loader.classList.contains('hide') && !loader.hidden) {
        pendingSync = true;
        if (!loaderObserver && !retry) retry = window.setTimeout(function () { retry = 0; syncNative(); }, 300);
        return;
      }
      pendingSync = false;
      variant.available = row.available;
      container.dispatchEvent(new CustomEvent('variantChange', { bubbles: true, detail: { variant: Object.assign({}, variant), fvStockRefresh: true } }));
    }
    function cancelRequest() {
      sequence += 1;
      if (pending) pending.abort();
      pending = null;
      window.clearTimeout(timeout);
      timeout = 0;
    }
    function plan() {
      window.clearTimeout(timer);
      timer = usable() && selectedId ? window.setTimeout(refresh, 60000) : 0;
    }
    function refresh() {
      window.clearTimeout(debounce);
      debounce = 0;
      window.clearTimeout(timer);
      timer = 0;
      if (!usable() || !selectedId) { plan(); return; }
      cancelRequest();
      var id = selectedId;
      var request = ++sequence;
      var requestController = new AbortController();
      pending = requestController;
      var url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', data.sectionId);
      url.searchParams.set('variant', id);
      timeout = window.setTimeout(function () { requestController.abort(); }, 10000);
      fetch(url.href, { credentials: 'same-origin', cache: 'no-store', signal: requestController.signal, headers: { Accept: 'text/html' } }).then(function (response) {
        if (!response.ok) throw new Error('Section unavailable');
        return response.text();
      }).then(function (html) {
        if (stopped || request !== sequence || id !== selectedId || !root.isConnected) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var candidates = doc.querySelectorAll(selector + ' script[data-fv-commerce-data]');
        var found = null;
        Array.from(candidates).some(function (candidate) {
          var result = read(candidate);
          if (result && String(result.data.productId) === String(data.productId) && String(result.data.sectionId) === String(data.sectionId) && result.rows.has(id)) { found = result; return true; }
          return false;
        });
        if (!found) return;
        rows = found.rows;
        freshRows = found.rows;
        render();
        syncNative();
      }).catch(function () {
        // A failed check preserves the last confirmed availability.
      }).then(function () {
        if (request !== sequence) return;
        window.clearTimeout(timeout);
        timeout = 0;
        pending = null;
        plan();
      });
    }
    function requestSoon() {
      if (!usable()) return;
      window.clearTimeout(debounce);
      debounce = window.setTimeout(refresh, 200);
    }
    root.addEventListener('variantChange', function (event) {
      if (event.detail && event.detail.fvStockRefresh) return;
      cancelRequest();
      pendingSync = false;
      var variant = event.detail && event.detail.variant;
      selectedId = variant && variant.id ? String(variant.id) : null;
      if (variant && selectedId) {
        var fresh = freshRows.get(selectedId);
        if (fresh) variant.available = fresh.available;
        nativeVariants.set(selectedId, variant);
        if (!fresh && rows.has(selectedId)) {
          var known = rows.get(selectedId);
          rows.set(selectedId, { id: selectedId, available: variant.available, state: variant.available ? (known.state === 'out' ? 'available' : known.state) : 'out' });
        }
      }
      render();
      plan();
      requestSoon();
    }, { capture: true, signal: signal });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        window.clearTimeout(timer);
        window.clearTimeout(debounce);
        cancelRequest();
      } else requestSoon();
    }, { signal: signal });
    ['focus', 'pageshow', 'online'].forEach(function (name) { window.addEventListener(name, requestSoon, { signal: signal }); });
    if (loader && 'MutationObserver' in window) {
      loaderObserver = new MutationObserver(function () { if (pendingSync) syncNative(); });
      loaderObserver.observe(loader, { attributes: true, attributeFilter: ['class', 'hidden'] });
    }
    instances.set(root, function () {
      stopped = true;
      controller.abort();
      cancelRequest();
      [timer, debounce, retry].forEach(function (id) { window.clearTimeout(id); });
      if (loaderObserver) loaderObserver.disconnect();
      instances.delete(root);
    });
    render();
    plan();
  }
  function initializeWithin(scope) { roots(scope).forEach(initialize); }
  document.addEventListener('shopify:section:load', function (event) { initializeWithin(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { roots(event.target).forEach(function (root) { var stop = instances.get(root); if (stop) stop(); }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeWithin(document); }, { once: true });
  else initializeWithin(document);
}());


  } catch(e) { console.error(e); }
})();
})();
